import React from 'react';
import { Panel } from '@ktr/ktr-materialui-react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Fade, Divider } from '@material-ui/core';
import { FormattedHTMLMessage, useIntl } from 'react-intl';
import { Clampex, ProductInputData } from '../../redux/product/productTypes';
import GridResultRow from './GridResultRow';
import ProductTable from './ProductTable';
import { LanguageState } from '../../redux/state';
import { ClampexType } from '../../types/types';

const useStyle = makeStyles({
    panel: {
        marginTop: "20px",
        marginRight: "10px"
    },
    valueLabel: {
        fontSize: "1.05em"
    },
    valueGrid: {
        fontSize: "1.05em",
       
    },
    valueEnd: {
        fontSize: "1.05em"
    },
    OuterLineGrid: {
        marginBottom: "5px",
        marginTop: "5px",
    },
  gridMargin: {
          /*'@media (max-width: 600px)' : {
                marginBottom: "70px"
        },
        marginBottom: "10px",
        marginTop: "10px"*/
    },
    divider: {
        marginTop: "15px",
        marginBottom: "15px"
    }
});

interface Props {
    currentProduct: Clampex,
    language: LanguageState,
    productInputData: ProductInputData,
    getPDFFile():any
}


export default function Result(props: Props) {
    const classes = useStyle();
    const { formatMessage: f } = useIntl();

    if(props.currentProduct.calculationOutputData != null || props.currentProduct.calculationOutputData != undefined)
        console.log("permissibleShaftInnerDiameter: ", props.currentProduct.calculationOutputData.permissibleShaftInnerDiameter);
    console.log("shaftinnerdiameter diw",props.productInputData.shaftInnerDiameter_diw || "");

    return (
        <Fade timeout={500} in={props.currentProduct.calculationOutputData !== undefined}>
            <div>
                { /*check if the calculationOutputData and the Productdata is undefined. If it is not display data.*/}
                {props.currentProduct.calculationOutputData !== undefined && props.currentProduct.productData !== undefined && props.productInputData !== undefined ?
                    <Panel title={<b>{f({ id: 'app.result.result' }) + ":"}</b>} className={classes.panel}>
                           <h3><FormattedHTMLMessage id="app.calc.result.info" /></h3>
                        <ProductTable 
                            getPDFFile={props.getPDFFile}
                            language={props.language} 
                            productData={props.currentProduct.productData} 
                            clampexTypeAttributes={props.currentProduct.clampexType}
                            clampexType={props.currentProduct.type}
                            calculationOutputData={props.currentProduct.calculationOutputData} 
                        />
                        <Grid item xs={12}>
                                <Divider className={classes.divider}></Divider>
                                <h3><FormattedHTMLMessage id="app.calc.result" /></h3>

                            </Grid>
                        <Grid style={{marginTop: "20px"}} container>

                            <GridResultRow value={props.currentProduct.calculationOutputData.resultingTransmittableTorque}
                                afterValue="Nm"
                                label={<FormattedHTMLMessage id="app.resultingTransmittableTorqueLabel" />}
                                classNameOuterGrid={classes.OuterLineGrid}
                                classNameLabel={classes.valueLabel}
                                classNameValue={classes.valueGrid}
                                classNameAfterValue={classes.valueEnd} />

                            <GridResultRow value={props.currentProduct.calculationOutputData.resultingTransmittableAxialForce}
                                afterValue="kN"
                                label={<FormattedHTMLMessage id="app.resultingTransmittableAxialForceLabel" />}
                                classNameOuterGrid={[classes.gridMargin, classes.OuterLineGrid].join(' ')}
                                classNameLabel={classes.valueLabel}
                                classNameValue={classes.valueGrid}
                                classNameAfterValue={classes.valueEnd} />
                            
                            <Grid item xs={12}>
                                <Divider className={classes.divider}></Divider>
                            </Grid>

                            <GridResultRow value={props.currentProduct.calculationOutputData.resultingSurfacePressureCEShaft}
                                afterValue="N/mm²"
                                label={<FormattedHTMLMessage id="app.resultingTransmittableSurfacePressureShaftLabel" />}
                                classNameOuterGrid={classes.OuterLineGrid}
                                classNameLabel={classes.valueLabel}
                                classNameValue={classes.valueGrid}
                                classNameAfterValue={classes.valueEnd} />
                            
                            {   //do not show when ktr700 is selected
                                props.currentProduct.type !== ClampexType.KTR700 ?
                            <GridResultRow value={props.currentProduct.calculationOutputData.resultingSurfacePressureCEHub}
                                    afterValue="N/mm²"
                                    label={<FormattedHTMLMessage id="app.resultingTransmittableSurfacePressureHubLabel" />}
                                    classNameOuterGrid={[classes.gridMargin, classes.OuterLineGrid].join(' ')}
                                    classNameLabel={classes.valueLabel}
                                    classNameValue={classes.valueGrid}
                                    classNameAfterValue={classes.valueEnd} />
                                : ""}
                            <Grid item xs={12}>
                                <Divider className={classes.divider}></Divider>
                            </Grid>
                            {   //do not show when ktr700 is selected
                                props.currentProduct.type !== ClampexType.KTR700 ?
                            <GridResultRow value={props.currentProduct.calculationOutputData.necessaryHubOuterDiameter}
                                afterValue="mm"
                                label={<FormattedHTMLMessage id="app.result.HubOuterDiameterLabel" />}
                                errorLabel={f({ id: 'app.result.errormsg1' })}
                                classNameOuterGrid={classes.OuterLineGrid}
                                classNameLabel={classes.valueLabel}
                                classNameValue={classes.valueGrid}
                                classNameAfterValue={classes.valueEnd}
                                error={props.currentProduct.calculationOutputData.necessaryHubOuterDiameter > (props.productInputData.hubOuterDiameter || "")}
                                />
                                : "" }
                            
                            
                            
                            { 
                            //Zulässiger Welleninnendurchmesser
                            props.productInputData.yieldStrengthShaft !== undefined
                                && props.productInputData.yieldStrengthShaft !== null ? 
                            <GridResultRow value={props.currentProduct.calculationOutputData.permissibleShaftInnerDiameter}
                                afterValue="mm"
                                label={<FormattedHTMLMessage id="app.result.PermissableShaftInnerDiameterLabel" />}
                                classNameOuterGrid={[classes.gridMargin, classes.OuterLineGrid].join(' ')}
                                classNameLabel={classes.valueLabel}
                                classNameValue={classes.valueGrid}
                                classNameAfterValue={classes.valueEnd} 
                                errorLabel={f({ id: 'app.result.errormsg2' })}
                                //error={props.currentProduct.calculationOutputData.tangentialStressShaft < (-props.productInputData.yieldStrengthShaft || "") }
                                error={(props.currentProduct.calculationOutputData.permissibleShaftInnerDiameter || 0) < (props.productInputData.shaftInnerDiameter_diw || "")}
                                /> 
                                : ""}

                            <Grid item xs={12}>
                                <Divider className={classes.divider}></Divider>
                            </Grid>
                            {props.currentProduct.calculationOutputData.tangentialStressShaft !== undefined
                                && props.currentProduct.calculationOutputData.tangentialStressShaft !== null 
                                && props.productInputData.yieldStrengthShaft !== undefined
                                && props.productInputData.yieldStrengthShaft !== null ?
                            <GridResultRow value={props.currentProduct.calculationOutputData.tangentialStressShaft}
                                    afterValue="N/mm²"
                                    label={<FormattedHTMLMessage id="app.result.TangentialShaftLabel" />}
                                    classNameOuterGrid={classes.OuterLineGrid}
                                    classNameLabel={classes.valueLabel}
                                    classNameValue={classes.valueGrid}
                                    classNameAfterValue={classes.valueEnd} 
                                    errorLabel={f({ id: 'app.result.errormsg3' })}
                                    error={props.currentProduct.calculationOutputData.tangentialStressShaft < (-props.productInputData.yieldStrengthShaft || "") }
                                    />
                                : ""}
                            


                            {props.currentProduct.calculationOutputData.tangentialStressShaftWithInnerDiam !== undefined
                                && props.currentProduct.calculationOutputData.tangentialStressShaftWithInnerDiam !== null
                                && props.productInputData.yieldStrengthShaft !== undefined
                                && props.productInputData.yieldStrengthShaft !== null ?
                            <GridResultRow value={props.currentProduct.calculationOutputData.tangentialStressShaftWithInnerDiam}
                                    afterValue="N/mm²"
                                    label={<FormattedHTMLMessage id="app.result.TangentialShaftWithShaftInnerDiameterLabel" />}
                                    classNameOuterGrid={classes.OuterLineGrid}
                                    classNameLabel={classes.valueLabel}
                                    classNameValue={classes.valueGrid}
                                    classNameAfterValue={classes.valueEnd}
                                    errorLabel={f({ id: 'app.result.errormsg3' })}
                                    error={props.currentProduct.calculationOutputData.tangentialStressShaftWithInnerDiam < (-props.productInputData.yieldStrengthShaft || "")}
                                    />
                                : ""}

                            {   //do not show when ktr700 is selected
                                props.currentProduct.type !== ClampexType.KTR700 ?
                            <GridResultRow value={props.currentProduct.calculationOutputData.tangentialStressHub}
                                afterValue="N/mm²"
                                label={<FormattedHTMLMessage id="app.result.TangentialHubLabel" />}
                                classNameOuterGrid={[classes.gridMargin, classes.OuterLineGrid].join(' ')}
                                classNameLabel={classes.valueLabel}
                                classNameValue={classes.valueGrid}
                                classNameAfterValue={classes.valueEnd}
                                errorLabel={f({ id: 'app.result.errormsg4' })}
                                error={props.currentProduct.calculationOutputData.tangentialStressHub > (props.productInputData.yieldStrengthHub || "")} />
                                : ""}
                            <Grid item xs={12}>
                                <Divider className={classes.divider}></Divider>
                            </Grid>
                            
                            <GridResultRow value={props.currentProduct.calculationOutputData.resultingTotalTorque}
                                afterValue="Nm"
                                label={<FormattedHTMLMessage id="app.result.totalTorque" />}
                                classNameOuterGrid={[classes.gridMargin, classes.OuterLineGrid].join(' ')}
                                classNameLabel={classes.valueLabel}
                                classNameValue={classes.valueGrid}
                                classNameAfterValue={classes.valueEnd}
                                errorLabel={f({ id: 'app.result.errormsg5' })}
                                error={(1.5 * props.currentProduct.calculationOutputData.resultingTotalTorque || "") > props.currentProduct.calculationOutputData.resultingTransmittableTorque}    
                                />
                            <Grid item xs={12}>
                                <Divider className={classes.divider}></Divider>
                            </Grid>
                            <GridResultRow value={props.currentProduct.calculationOutputData.safetyFactorTorque || " "}
                                afterValue="&nbsp;"
                                label={<FormattedHTMLMessage id="app.result.securityFactorTorque" />}
                                classNameOuterGrid={classes.OuterLineGrid}
                                classNameLabel={classes.valueLabel}
                                classNameValue={classes.valueGrid}
                                classNameAfterValue={classes.valueEnd} 
                                errorLabel={f({ id: 'app.result.errormsg5' })}
                                error={(1.5 * props.currentProduct.calculationOutputData.resultingTotalTorque || "") > props.currentProduct.calculationOutputData.resultingTransmittableTorque}    
                                />
                        </Grid>
                    </Panel>
                    : ""}
            </div>
        </Fade>
    )
}
